// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3W6-5"};